import { useCallback, useEffect, useState } from 'react'

import { Loading } from 'components/ui/Loading/Loading'
import {
  Cargo,
  useContainers,
  useContainersActions,
} from 'services/warehouse-containers/containers'
import { ContainerItem } from 'components/ContainerItem/ContainerItem'
import { MovementDirection } from 'components/MovementDirection/MovementDirection'
import { Slider } from 'components/ui/Slider/Slider'
import { Button } from 'components/ui/Button/Button'
import { Filter } from './components/Filter/Filter'
import { Warehouse, WarehouseType } from 'services/warehouse-containers/warehouse'

import './transfer.style.css'

export const Transfer = () => {
  const [selectedCargo, setSelectedCargo] = useState<Cargo>(null)
  const [isActive, setIsActive] = useState<boolean>(false)
  const [targetWarehouse, setTargetWarehouse] = useState<Warehouse | null>(null)

  const {
    isLoading,
    setFilters,
    args: currentWarehouse,
    setArgs,
    reset,
    containers: containerList,
    refreshValues,
  } = useContainers()
  const { isLoading: isActionProcessing, transferCargo } = useContainersActions()

  useEffect(() => () => reset(), [])

  const renderCargoItem = useCallback((el: Cargo, index: number) => {
    const handleOnSubmit = (cargo: Cargo) => {
      setSelectedCargo(cargo)
      setIsActive(true)
    }

    return <ContainerItem key={index} element={el} onSubmut={handleOnSubmit}></ContainerItem>
  }, [])

  const renderCargoList = useCallback(() => {
    if (isLoading || isActionProcessing) return <Loading />

    return <div className="transfer-page-list">{containerList?.map(renderCargoItem)}</div>
  }, [isLoading, isActionProcessing, containerList])

  const handleOnSubmit = useCallback(async () => {
    const containerIds = selectedCargo?.containers?.map((el) => el.id)

    setIsActive(false)

    await transferCargo(targetWarehouse?.id, selectedCargo?.id, containerIds)

    refreshValues()
  }, [
    targetWarehouse?.id,
    selectedCargo?.id,
    selectedCargo?.containers,
    selectedCargo?.comments?.storekeeperComment,
  ])

  const renderFilter = useCallback(() => {
    if (!targetWarehouse?.id) return null

    const handleOnProductChange = (products: string[]) => {
      setFilters((currValue) => ({ ...currValue, products }))
    }

    const handleOnIntervalChange = (interval: [Date, Date]) => {
      setFilters((currValue) => ({ ...currValue, interval }))
    }

    const handleOnOrderNumberChange = (orderNumber: number) => {
      setFilters((currValue) => ({ ...currValue, orderNumber }))
    }

    const handleOnCotnainerSealChange = (containerSeal: number) => {
      setFilters((currValue) => ({ ...currValue, containerSeal }))
    }

    return (
      <Filter
        onIntervalChange={handleOnIntervalChange}
        onProductsChange={handleOnProductChange}
        onOrderNumberChange={handleOnOrderNumberChange}
        onContainerSealChange={handleOnCotnainerSealChange}
      />
    )
  }, [setFilters, targetWarehouse?.id])

  const renderSliderHeader = useCallback(() => {
    if (!selectedCargo) return ''

    return `#${selectedCargo?.orderNumber}`
  }, [selectedCargo])

  const handleOnSearch = (fromWarehouse: Warehouse, toWarehouse: Warehouse) => {
    setArgs(fromWarehouse)
    setFilters((prev) => {
      const { courierWarehouseId, ...prevValue } = prev

      if ([WarehouseType.Courier].includes(toWarehouse.type)) {
        return { ...prevValue, courierWarehouseId: toWarehouse.id }
      }

      return prevValue
    })
    setTargetWarehouse(toWarehouse)
  }

  const handleOnClose = () => setIsActive(false)

  return (
    <>
      <MovementDirection
        fromWarehouse={currentWarehouse}
        toWarehouse={targetWarehouse}
        onSearch={handleOnSearch}
      />
      {renderFilter()}
      {renderCargoList()}
      <Slider isActive={isActive} onClose={handleOnClose} height="150px">
        <div className="transfer-page-list__slider">
          <h2>Переместить {renderSliderHeader()}?</h2>
          <div className="transfer-page-list__slider-controlls">
            <span style={{ marginRight: '0.5rem' }}>
              <Button title="Переместить" handleOnSubmit={handleOnSubmit} />
            </span>
            <Button outline title="Отмена" handleOnSubmit={handleOnClose} />
          </div>
        </div>
      </Slider>
    </>
  )
}
